import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalService } from 'projects/mariano-max/src/app/core/app-shared/public-api';
import { EcommerceGenericoService, Usuario } from 'projects/mariano-max/src/app/core/ecommerce-generico/public-api';
import { MarianomGeneral } from '../marianom-general.service';
import { Form, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Ciudad } from 'projects/mariano-max/src/app/core/ecommerce-generico/interfaces/ciudades-envío.interface';

@Component({
  selector: 'mis-datos-mmax',
  templateUrl: './misdatosmmax.component.html',
  styleUrls: ['./misdatosmmax.component.scss']
})

export class MisdatosmmaxComponent implements OnInit {
  @Input('mode') modo: string;

  whatsappsrc: string = '../../assets/icons/whatsapp-logo.svg';
  correosrc: string = '../../assets/icons/mail.svg';
  user: Usuario;
  registroHab: string;
  beneficios: string;
  formularioDatosUsuario: UntypedFormGroup;
  habilitarCambiarDatos: boolean = false;
  guardadoExitoso: boolean = false;
  guardadoProblema: boolean = false;
  guardando: boolean = false;
  ciudadesHabilitadas: Ciudad[] = [];
  tieneCiudadElegida: boolean = false;
  constructor(private genServ: EcommerceGenericoService, private router: ActivatedRoute, private modal: ModalService, private formBuilder: UntypedFormBuilder) {

    this.formularioDatosUsuario = this.formBuilder.group({
      nombre: [{ value: '', disabled: true }, Validators.maxLength(30)],
      dni: [{ value: '', disabled: true }, Validators.min(9999)],
      direccion: [{ value: '', disabled: true }, Validators.maxLength(100)],
      telefonos: [{ value: '', disabled: true }],
      ciudad: [{ value: '', disabled: true }]
    });

    this.genServ.getUsuarioProvider().subscribe({
      next: data => {
        if (!data) return; // Validación por seguridad
        this.user = data;

        this.formularioDatosUsuario.patchValue({
          nombre: this.user.nombre,
          dni: this.user.dni,
          direccion: this.user.direccion,
          telefonos: this.user.telefonos,
          ciudad: this.user.ciudad
        });
        // Verificamos si tiene ciudad elegida
        this.verificarCiudadElegida();

        if (this.ciudadesHabilitadas.length === 0 && this.user && this.user.sucursal) {
          this.genServ.getCiudades(this.user.sucursal).subscribe((data: any) => {
            this.ciudadesHabilitadas = data.registros;
          })
        }
      }
    });

    this.genServ.getRegistroHabilitado().subscribe(data => {
      this.registroHab = data;
    });
    this.genServ.returnBeneficios().subscribe(data => {
      this.beneficios = data;
    })


  }

  ngOnInit(): void {
    this.router.data.subscribe({
      next: data => {
        this.modo = data['mode'] || this.modo || 'normal';
      }
    });
    this.ciudadesHabilitadas = this.genServ.ciudadesHabilitadasParaEnvio ? this.genServ.ciudadesHabilitadasParaEnvio.slice() : [];

    this.verificarCiudadElegida()

  }
  verificarCiudadElegida() {
    if (!this.user || !this.ciudadesHabilitadas) return;

    const existe = this.ciudadesHabilitadas.some(c => c.ciudad == this.user.ciudad);

    this.tieneCiudadElegida = existe;
  }

  get nombre() {
    return this.formularioDatosUsuario.get('nombre')
  }

  get dni() {
    return this.formularioDatosUsuario.get('dni')
  }

  get direccion() {
    return this.formularioDatosUsuario.get('direccion')
  }


  get telefonos() {
    return this.formularioDatosUsuario.get('telefonos')
  }

  /*   get codigopostal(){
    return this.formularioDatosUsuario.get('codigopostal')
  } */

  get ciudad() {
    return this.formularioDatosUsuario.get('ciudad')
  }

  modificarDatos() {
    this.formularioDatosUsuario.get('nombre').enable()
    this.formularioDatosUsuario.get('dni').enable()
    this.formularioDatosUsuario.get('direccion').enable()
    //this.formularioDatosUsuario.get('codigopostal').enable()
    this.formularioDatosUsuario.get('ciudad').enable()
    this.formularioDatosUsuario.get('telefonos').enable()
    this.habilitarCambiarDatos = true;
    this.guardadoExitoso = false;
    this.guardadoProblema = false;
    //this.modal.open('formulario-mis-datos')
  }

  cancelarCambios() {
    //this.formularioDatosUsuario.reset()
    this.formularioDatosUsuario.patchValue({
      nombre: this.user.nombre || '',
      dni: this.user.dni || '',
      direccion: this.user.direccion || '',
      telefonos: this.user.telefonos || '',
      ciudad: this.user.ciudad || ''
    });
    this.formularioDatosUsuario.get('nombre').disable()
    this.formularioDatosUsuario.get('dni').disable()
    this.formularioDatosUsuario.get('direccion').disable()
    //this.formularioDatosUsuario.get('codigopostal').disable()
    this.formularioDatosUsuario.get('telefonos').disable()
    this.formularioDatosUsuario.get('ciudad').disable()
    this.habilitarCambiarDatos = false;
  }

  guardarCambios() {
    this.guardando = true;
    //console.log('guardar cambios usuario', this.formularioDatosUsuario.value);
    this.genServ.modificarDatosUsuario(this.formularioDatosUsuario.value).subscribe({
      next: respuestaExitosa => {
        //console.log('guardado Exitoso');
        this.habilitarCambiarDatos = false;
        this.guardadoExitoso = true;
        let nuevosDatosUsuario: Usuario = JSON.parse(JSON.stringify(this.genServ.getUser()));
        nuevosDatosUsuario.ciudad = parseInt(this.formularioDatosUsuario.get('ciudad').value);
        this.genServ.setUser(nuevosDatosUsuario);
        this.tieneCiudadElegida = true;
        setTimeout(() => {
          this.guardadoExitoso = false;
        }, 15000);
      },
      error: respuestaError => {
        //console.log('problema en guardado');
        this.guardadoProblema = true;
        setTimeout(() => {
          this.guardadoProblema = false;
        }, 15000);
      },
      complete: () => {
        this.guardando = false;
      }
    })

  }

  resetPass() {
    if (this.registroHab === 'S') {
      this.modal.open('send-reset-pass-saltearPedidoDeMail');
    }
    if (this.beneficios === 'S') {
      this.modal.open('restore-pass-modal');
    }
  }

}
